<template>
  <div id="main">
    <mv-full-page
      :isPointer="false"
      :isV="isV"
      :pages="pageCount"
      :page.sync="currentPage"
      :isCache="true"
      height="calc(100% - 0.72rem)"
      :transition="{
        duration: '500ms', // 动画时长
        timingFun: 'ease', // 动画速度曲线
        delay: '0s' // 动画延迟
      }"
      @rollEnd="onRollEnd"
      :config="{
        disabled: this.localValue
      }"
    >
      <template #page1>
        <div class="video">
          <div class="video-container">
            <video
              class="video"
              ref="myVideo"
              :src="videoPath"
              muted
              autoplay
              loop
              @contextmenu.prevent
              playsinline
              preload="auto"
              x5-video-player-type="h5"
              webkit-playsinline="true"
              x5-playsinline="true"
              :poster="
                videoPath + '?x-oss-process=video/snapshot,t_0,f_jpg,m_fast'
              "
            ></video>
          </div>
          <img
            class="mask"
            alt=""
            :src="require('@/assets/img/product/h30/mask.png')"
          />
          <p class="title">澜渟 H30 series 盆底康复治疗仪</p>
          <p class="desc">
            「盆底+私密」对症改善松弛
          </p>
          <img
              class="price"
              alt=""
              :src="require('@/assets/img/product/h30/price.png')"
          />
          <div class="copyright">
            广告审查批准文号:苏械广审(文)第270729-17656号 盆底康复治疗仪
            医疗器械注册号:苏械注准20252091406<br />请仔细阅读产品说明书或者在医务人员的指导下购买和使用
            禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司
          </div>
        </div>
      </template>
      <template #page2>
        <div class="banner">
          <full-swiper :hover-scale="false" :datas="bannerList"></full-swiper>
          <div class="img-copyright">
            广告审查批准文号:苏械广审(文)第270731-17967号 盆底康复治疗仪
            医疗器械注册号:苏械注准20252091406<br />请仔细阅读产品说明书或者在医务人员的指导下购买和使用
            禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司
          </div>
        </div>
      </template>
      <template #page3>
        <div class="system">
          <p>双向评估标准 科学分析肌底健康</p>
          <img-swiper-v3 :datas="systemList"></img-swiper-v3>
          <div class="img-copyright" style="color: #999;">
            广告审查批准文号:苏械广审(文)第270731-17968号 盆底康复治疗仪
            医疗器械注册号:苏械注准20252091406<br />请仔细阅读产品说明书或者在医务人员的指导下购买和使用
            禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司
          </div>
        </div>
      </template>
      <template #page4>
        <div class="pattern">
          <p>生电联合技术  疗程化训练</p>
          <div class="video-list">
            <div class="video-item">
              <video
                src="//rightinhome.oss-cn-hangzhou.aliyuncs.com/website/product-h30-1.mp4"
                muted
                autoplay
                loop
                @contextmenu.prevent
                playsinline="true"
                preload="auto"
                x5-video-player-type="h5"
                webkit-playsinline="true"
                x5-playsinline="true"
              ></video>
              <div class="title">神经肌肉电刺激</div>
              <div class="desc">
                采用双向对称方波技术，针对不同层级细胞肌肉进行激活
              </div>
            </div>
            <div class="video-item">
              <video
                src="//rightinhome.oss-cn-hangzhou.aliyuncs.com/website/product-h30-2.mp4"
                muted
                autoplay
                loop
                @contextmenu.prevent
                playsinline="true"
                preload="auto"
                x5-video-player-type="h5"
                webkit-playsinline="true"
                x5-playsinline="true"
              ></video>
              <div class="title">肌电生物反馈</div>
              <div class="desc">
                通过阴道电极采集盆底肌表面的肌电信号转化为可视化图像，搭建盆底肌和中枢神经的联系，建立正确的收缩模式
              </div>
            </div>
          </div>
          <div class="img-copyright" style="color: #999;">
            广告审查批准文号:苏械广审(文)第270819-19757号 盆底康复治疗仪
            医疗器械注册号:苏械注准20252091406<br />请仔细阅读产品说明书或者在医务人员的指导下购买和使用
            禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司
          </div>
        </div>
      </template>
      <template #page5>
        <div class="wuxian">
          <p>无线体验升级，随享无拘无束</p>
          <img-swiper-v4 :datas="wuxianList"></img-swiper-v4>
          <div class="img-copyright" style="bottom: 0.12rem;">
            广告审查批准文号:苏械广审(文)第270729-17673号 盆底康复治疗仪
            医疗器械注册号:苏械注准20252091406<br />请仔细阅读产品说明书或者在医务人员的指导下购买和使用
            禁忌内容或者注意事项详见说明书 南京麦豆健康科技有限公司
          </div>
        </div>
      </template>
    </mv-full-page>
  </div>
</template>

<script>
import "@/assets/css/animate.min.css";
import "mv-full-page/lib-dist/mv-full-page.css";
import MvFullPage from "mv-full-page";
import Vue from "vue";
import { FullSwiper } from "@/components/full-swiper";
import { ImgSwiperV3 } from "@/components/img-swiper-v3";
import { ImgSwiperV4 } from "@/components/img-swiper-v4";
import directives from "@/utils/directives";

Vue.use(directives);
Vue.use(MvFullPage);

export default {
  data() {
    return {
      localValue: this.value,
      isV: true,
      currentPage: 1,
      pageCount: 5,
      videoPath: `//rightinhome.oss-cn-hangzhou.aliyuncs.com/website/product-h30.mp4`,
      bannerList: [
        {
          path: require("@/assets/img/product/h30/banner-1.png")
        },
        {
          path: require("@/assets/img/product/h30/banner-2.png")
        }
      ],
      systemList: [
        {
          path: require("@/assets/img/product/h30/system-1.png")
        },
        {
          path: require("@/assets/img/product/h30/system-2.png")
        },
        {
          path: require("@/assets/img/product/h30/system-3.png")
        },
        {
          path: require("@/assets/img/product/h30/system-4.png")
        },
        {
          path: require("@/assets/img/product/h30/system-5.png")
        }
      ],
      wuxianList: [
        {
          path: require("@/assets/img/product/h30/wuxian-1.png"),
          title: "无线一体化"
        },
        {
          path: require("@/assets/img/product/h30/wuxian-2.png"),
          title: "充电收纳一体"
        },
        {
          path: require("@/assets/img/product/h30/wuxian-3.png"),
          title: "全身防水"
        },
        {
          path: require("@/assets/img/product/h30/wuxian-4.png"),
          title: "终生零耗材"
        }
      ]
    };
  },
  props: {
    value: {
      //数据源（必填）
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.$parent.$emit("rollInit");
  },
  methods: {
    onRollEnd(page) {
      this.$parent.$emit("rollPage", page);
      if (page === this.pageCount) {
        this.$parent.$emit("rollEnd");
      } else {
        this.$parent.$emit("rollTop");
      }
    }
  },
  watch: {
    value(val) {
      this.localValue = val;
    },
    currentPage(val) {
      if (val === 1) {
        this.localValue = false;
      }
    }
  },
  components: {
    FullSwiper,
    ImgSwiperV3,
    ImgSwiperV4
  }
};
</script>

<style lang="scss" scoped>
.full-page-wrapper {
  top: 0.72rem;

  // 强制第一页全屏
  /deep/ .all-page .page:nth-child(1) {
    height: calc(100% / 5 + 0.72rem) !important;
    margin-top: -0.72rem !important;
  }
}

.video {
  position: relative;
  width: 100%;
  height: 100%;

  > .video-container {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;

    > .video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  >.mask {
    position: absolute;
    bottom: 0;
    width: 100%;
  }

  > .copyright {
    position: absolute;
    bottom: 0.24rem;
    left: 0;
    width: 100%;
    font-weight: 400;
    font-size: 0.12rem;
    color: rgba(255, 255, 255, 0.64);
    line-height: 0.17rem;
    text-align: center;
    pointer-events: none;
  }

  > .title {
    position: absolute;
    bottom: 1.87rem;
    left: 0;
    width: 100%;
    font-weight: 500;
    font-size: 0.56rem;
    color: #fff;
    line-height: 0.78rem;
    text-align: center;
    pointer-events: none;
  }

  > .desc {
    position: absolute;
    bottom: 1.27rem;
    width: 100%;
    font-weight: 500;
    font-size: 0.28rem;
    color: #fff;
    padding-left: 6.28rem;
  }
  > .price {
    position: absolute;
    bottom: 1.18rem;
    left: 9.85rem;
    width: 3.07rem;
  }
}

.banner {
  position: relative;
  width: 100%;
  height: 100%;
  background: #fff;
}

.system {
  position: relative;
  width: 100%;
  height: 100%;
  background: url("../../assets/img/product/h30/system-bg.png") no-repeat;
  background-size: cover;
  background-position-y: top;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  > p {
    font-weight: 500;
    font-size: 0.56rem;
    color: #000000;
    line-height: 0.78rem;
    text-align: center;
  }

  > .swiper {
    width: 100%;
    height: 6.42rem;
  }
}

.pattern {
  width: 100%;
  height: 100%;
  position: relative;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  > p {
    font-weight: 500;
    font-size: 0.56rem;
    color: #000000;
    line-height: 0.78rem;
    text-align: center;
  }

  > .video-list {
    height: 6.28rem;
    padding: 0 0.9rem;
    width: 100%;
    display: flex;
    justify-content: space-between;

    > .video-item {
      border-radius: 0.24rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: #f5f5f7;
      width: 8.58rem;

      > video {
        width: 100%;
        height: 4.82rem;
        object-fit: cover;
        border-radius: 0.24rem 0.24rem 0 0;
      }

      > .title {
        margin-top: 0.2rem;
        font-weight: 500;
        font-size: 0.28rem;
        color: #000000;
        line-height: 0.39rem;
      }

      > .desc {
        padding: 0 0.5rem;
        margin-top: 0.12rem;
        font-weight: 400;
        font-size: 0.2rem;
        color: #666666;
        line-height: 0.28rem;
        text-align: center;
      }
    }
  }
}

.wuxian {
  position: relative;
  width: 100%;
  height: 100%;
  background: url("../../assets/img/product/h30/wuxian-bg.png") no-repeat;
  background-size: cover;
  background-position-y: center;

  > p {
    font-weight: 500;
    font-size: 0.56rem;
    color: #000000;
    line-height: 0.78rem;
    width: 100%;
    text-align: center;
    position: absolute;
    top: 1.2rem;
  }

  > .swiper {
    position: absolute;
    top: 2.79rem;
    right: 0;
    width: 12.58rem;
    height: 5.93rem;
  }
}
</style>
